export default __webpack_public_path__ + "static/media/vert-menu.1b7947cd.svg";